import { PROVIDER_SEARCH_PAGES } from "core/consts";
import { formatUnixDate } from "core/model/utils/dates";
import { ProviderSearchPage } from "core/types";
import { getUnixTime } from "date-fns";
import Translations from "translations/types";

const todayDe = formatUnixDate(getUnixTime(new Date()), "de");

export const pageMetaDataBavaria = (
  page: ProviderSearchPage,
): {
  title: (translations: Translations) => string;
  description?: (translations: Translations) => string;
} => {
  const titleOf = (translations: Translations, pageTitle: string) =>
    `${translations.providersearch.header.title} | ${pageTitle}`;

  switch (page) {
    case PROVIDER_SEARCH_PAGES.ACCOUNTS:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.accountPageDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.accountPageTitle,
          ),
      };
    case PROVIDER_SEARCH_PAGES.PATIENT_DASHBOARD:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.searchDashboardDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.searchDashboardTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.PROVIDER_DETAILS_PAGE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.providerProfileDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.providerProfileTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.CONSULTANT_DETAILS_PAGE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.consultantProfileDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.consultantProfileTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.GLOSSARY:
      return {
        description: (translations) =>
          translations.providersearch.glossary.pageDescription,
        title: (translations) =>
          titleOf(translations, translations.providersearch.glossary.pageTitle),
      };

    case PROVIDER_SEARCH_PAGES.LISTING:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.listingsDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.listingsTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.PRINT_LISTING:
      return {
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.printListingPageTitle({
              date: todayDe,
            }),
          ),
      };

    case PROVIDER_SEARCH_PAGES.LOGIN_WIZARD:
      return {
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.loginPageTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.ONBOARDING_FUNNEL_SEARCH_TYPE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.searchForDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.searchForTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.ONBOARDING_FUNNEL_SERVICES:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.specialNeedsDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.specialNeedsTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.ONBOARDING_FUNNEL_SOLUTIONS:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.solutionsDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.solutionsTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.ONBOARDING_FUNNEL_START_DATE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.startTimeDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.startTimeTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.ONBOARDING_FUNNEL_ZIP_CODE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.zipCodeDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.zipCodeTitle,
          ),
      };

    case PROVIDER_SEARCH_PAGES.REQUEST_PAGE:
      return {
        description: (translations) =>
          translations.providersearch.pageTitles.auctionResponseDescription,
        title: (translations) =>
          titleOf(
            translations,
            translations.providersearch.pageTitles.auctionResponseTitle,
          ),
      };

    default:
      return { title: () => "" };
  }
};
